/**
 *
 * Asynchronously loads the component for EventTeamDetail
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
